import { NotionAppRow } from '../components/NotionAppRow';
import type { AppRow } from '../type/AppRow';

export const notionAppRow: AppRow = {
  key: 'notion',
  name: 'Notion',
  AppComponent: NotionAppRow,
};
